export const usernameRegex = /^[a-zA-Z0-9._]{3,}$/;
export const passwordRegex = /^\S{6,}$/;
export const phoneNumberRegex = /^(\+98|0|0098|)9\d{9}$/;
export const phoneOrUsernameRegex = /^[a-zA-Z0-9._]{3,}$|^(\+98|0|0098|)9\d{9}$/;

export function usernameValidator(username: string) {
  return usernameRegex.test(username);
}

export function phoneNumberValidator(phoneNumber: string) {
  return phoneNumberRegex.test(phoneNumber);
}

export function passwordValidator(password: string) {
  return passwordRegex.test(password);
}
